import { put, call, select } from 'redux-saga/effects';
import * as actions from '../actions';
import axios from 'axios';
import * as constants from '../constants'
import * as utility from '../utility'
import { getApplication, getMain } from '../selectors/application';
import { fetchMyInfoConfiguration, fetchMyInfoDataCall } from '../../api/myinfo';

function authorizeSingPass(myInfoURL, myInfoClientID, reqAttributes, callbackURL, requestPurpose) {
  const authoriseUrl = myInfoURL +
    '?client_id=' + myInfoClientID +
    '&attributes=' + reqAttributes +
    '&purpose=' + requestPurpose +
    '&state=' + encodeURIComponent(utility.generateSixDigitRandomeNumber()) +
    '&redirect_uri=' + callbackURL;
  
    window.location = authoriseUrl;
};

function authorizeSingPassNew(myInfoURL, myinfoWithCPF, includeCpf, createCustomerFlow) {
  if(includeCpf && createCustomerFlow)
  {
    window.location = myinfoWithCPF;
  }
  else
  {
    window.location = myInfoURL;
  }
};



export function* authorizeSingPassSaga(action) {
  try {
    const { appForm, applicantDetails } = yield select(getApplication);
    const { myinfoUrl, myinfoWithCPF, createCustomerFlow, codeVerifier } = yield select(getMain);

    //Setting localStorage to use after callback
    localStorage.setItem('sessionId', action.sessionId);
    localStorage.setItem('appForm', JSON.stringify(appForm));
    localStorage.setItem('applicantDetails', JSON.stringify(applicantDetails));
    localStorage.setItem('includeCpf', action.includeCpf);
    localStorage.setItem('codeVerifier', codeVerifier);

    // const result = yield call(fetchMyInfoConfiguration);
    // const { url, clientId, requestAttributes, requestPurpose, callbackUrl } = result.data.data;

    yield call(
      authorizeSingPassNew,
      myinfoUrl,
      myinfoWithCPF,
      action.includeCpf,
      createCustomerFlow
    );

  } catch(error) {
    console.warn('There was an error using myinfo');
  }
}

export function* getMyInfoDataSaga(action) {
  yield put(actions.registerLoading());

  try {

    yield put(actions.updateSource(true));
    const applicationDetails = JSON.parse(localStorage.getItem('appForm'));

    const responseData = {
      data: {
        applicationDetails: applicationDetails,
        applicantDetails: constants.applicantDetails
      }
    };

    //Setting props again after window change
    yield put({ type: actions.getApplicationDetailsSuccess(responseData) });

    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
    yield put(actions.stageSuccess(4));

    const codeVerifier = localStorage.getItem('codeVerifier');
    const response = yield call(fetchMyInfoDataCall, action.payload.authCode, applicationDetails.make, action.payload.includeCpf, codeVerifier);

    responseData.data.applicantDetails = response.data.data;
    yield put({ type: actions.getApplicationDetailsSuccess(responseData) });

    const data = {
      token : localStorage.getItem('token'),
      refreshToken : localStorage.getItem('refreshToken')
    }

    yield put(actions.onCheckNRICSessionSuccess(data));

    //Resetting localStorage after use
    //localStorage.clear();
  } catch (error) {
    // Goto Manual Application
    yield put(actions.updateSource(false));
    yield put(actions.stageSuccess(4));
    yield put({ type: actions.onGetMyInfoDataFailed(error.response.data.msg) })
  }
  yield put(actions.unregisterLoading());
}

export function* getMyInfoDataFailed(action) {

  const applicationDetails = JSON.parse(localStorage.getItem('appForm'));

  const responseData = {
    data: {
      applicationDetails: applicationDetails,
      applicantDetails: constants.applicantDetails
    }
  };

  //Setting props again after window change
  yield put({ type: actions.getApplicationDetailsSuccess(responseData) });

  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  //Resetting localStorage after use
  //localStorage.clear();
  yield put({ type: actions.onGetMyInfoDataFailed(action.error) })
}
